var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"component-wrap",class:{ 'component-padded': _vm.base.padded, 'active': _vm.active }},[_c('div',{staticClass:"current-active"}),_c('div',{staticClass:"floorImg-title",style:('text-align:' + _vm.base.float)},[_vm._v(" "+_vm._s(_vm.base.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }